export enum PROPOSAL_FUNNEL_ENUM {
  SIMULATION_QUANTITY = 'simulation_quantity',
  PROPOSAL_QUANTITY = 'proposal_quantity',
  APPROVED_QUANTITY = 'approved_quantity',
  EFFECTIVE_QUANTITY = 'effective_quantity',
  CONTRACTS_QUANTITY = 'contracts_quantity'
}

export enum PANELS_TYPES_ENUM {
  MARKETING_SHARE = 'mktShare',
  MARKET_VISUALIZATION = 'mktVisualization',
  SANTANDER_AUTO_INSURANCE = 'santanderAutoInsurance',
  ACCOUNT_AMOUNT = 'accountAmount',
  WEBMOTORS = 'webmotors',
  PRODUCTION = 'production',
  POTENTIAL = 'potential',
  FPD10 = 'fpd10',
  OVER30_M3 = 'over30m3',
  CONTRACTS_AMOUNT = 'contractsAmount',
  SPREAD = 'spread',
  TYPES_SANTANDER_AUTO = 'typesSantanderAuto',
  CREDIT_LIFE_INSURANCE = 'creditLifeInsurance'
}

export const panelsResumedChartsProps = {
  contractsAmount: {
    title: 'Contratos (QTD)',
    slug: 'contratos_qtd',
    last_updated: String(new Date()),
    subtitles: [
      {
        title: 'Financiamentos',
        color: 'primary.800'
      },
      {
        title: 'Seguro Prestamista',
        color: 'primary.500'
      },
      {
        title: 'Seguro Auto',
        color: 'primary.300'
      }
    ],
    type: 'qtd'
  },
  contractsAmountGoodsAndServices: {
    title: 'Quantidade de Contratos',
    slug: 'qtd_de_contratos',
    last_updated: String(new Date()),
    subtitles: [
      {
        title: 'Quantidade de Contratos',
        color: 'primary.800'
      },
      {
        title: 'Seguro Prestamista',
        color: 'primary.500'
      }
    ],
    type: 'qtd'
  },
  production: {
    title: 'Produção (R$)',
    slug: 'producao',
    last_updated: String(new Date()),
    subtitles: [
      {
        title: 'Produção (R$)',
        color: 'primary.500'
      }
    ],
    type: 'currency'
  },
  spread: {
    title: 'Spread (%)',
    slug: 'spread',
    last_updated: String(new Date()),
    subtitles: [
      {
        title: 'Spread Bruto',
        color: 'primary.500'
      },
      {
        title: 'Spread Líquido',
        color: 'primary.300'
      }
    ],
    type: 'percentage'
  },
  potential: {
    title: 'Potencial (R$)',
    slug: 'potencial',
    last_updated: String(new Date()),
    subtitles: [
      {
        title: 'Potencial (R$)',
        color: 'primary.500'
      }
    ],
    type: 'currency'
  },
  mktShare: {
    title: 'Market Share (%)',
    slug: 'market_share',
    last_updated: String(new Date()),
    subtitles: [
      {
        title: 'Market Share %',
        color: 'primary.500'
      }
    ],
    type: 'percentage'
  },
  mktVisualization: {
    title: 'Vis. de mercado (%)',
    slug: 'visao_de_mercado',
    last_updated: String(new Date()),
    subtitles: [
      {
        title: 'Visualização de mercado %',
        color: 'primary.500'
      }
    ],
    type: 'percentage'
  },
  creditLifeInsurance: {
    title: 'Seguro Prestamista',
    slug: 'seguro_prestamista',
    last_updated: String(new Date()),
    subtitles: [
      {
        title: '% IP Seguro Prestamista (QTD)',
        color: 'primary.500'
      },
      {
        title: '% IP Seguro Prestamista (Volume)',
        color: 'primary.300'
      }
    ],
    type: 'percentage'
  },
  santanderAutoInsurance: {
    title: 'Seguro Santander Auto',
    slug: 'seguro_santander_auto',
    last_updated: String(new Date()),
    subtitles: [
      {
        title: '% IP Seguro Auto (Qtd)',
        color: 'primary.500'
      }
    ],
    type: 'percentage'
  },
  typesSantanderAuto: {
    title: 'Santander Auto Tipos (Qtd)',
    slug: 'sanander_auto_tipos',
    last_updated: String(new Date()),
    subtitles: [
      {
        title: 'Seguro Completo',
        color: 'primary.800'
      },
      {
        title: 'Seguro Incêndio Roubo e Furto',
        color: 'primary.500'
      },
      {
        title: 'Seguros Terceiros',
        color: 'gray.200'
      },
      {
        title: 'Seguros Avulsa',
        color: 'primary.300'
      }
    ],
    type: 'qtd'
  },
  accountAmount: {
    title: 'Quantidade de Contas',
    slug: 'qtd_de_contas',
    last_updated: String(new Date()),
    subtitles: [
      {
        title: 'Contas Abertas',
        color: 'primary.500'
      }
    ],
    type: 'qtd'
  },
  webmotors: {
    title: 'Webmotors',
    slug: 'webmotors',
    last_updated: String(new Date()),
    subtitles: [
      {
        title: 'Faturamento Webmotors (R$)',
        color: 'primary.500'
      }
    ],
    type: 'currency'
  },
  fpd10: {
    title: 'FPD10',
    slug: 'fpd10',
    last_updated: String(new Date()),
    subtitles: [
      {
        title: 'Contratos FPD10 (%)',
        color: 'primary.500'
      }
    ],
    type: 'percentage'
  },
  over30m3: {
    title: 'Over30 M3',
    slug: 'over30_m3',
    last_updated: String(new Date()),
    subtitles: [
      {
        title: 'Over 30 M3 (%)',
        color: 'primary.300'
      }
    ],
    type: 'percentage'
  }
}

export const panelsFullChartsProps = {
  contractsAmount: {
    title: 'Quantidade de Contratos',
    slug: 'qtd_contratos',
    last_updated: String(new Date()),
    subtitles: [
      {
        title: 'Qtd de Contratos',
        color: 'primary.800'
      },
      {
        title: 'Qtd Seguro Prestamista',
        color: 'primary.500'
      },
      {
        title: 'Qtd Seguro Auto',
        color: 'primary.300'
      }
    ],
    type: 'qtd'
  },
  contractsAmountGoodsAndServices: {
    title: 'Quantidade de Contratos',
    slug: 'qtd_contratos',
    last_updated: String(new Date()),
    subtitles: [
      {
        title: 'Qtd de Contratos',
        color: 'primary.800'
      },
      {
        title: 'Qtd Seguro Prestamista',
        color: 'primary.500'
      }
    ],
    type: 'qtd'
  },
  production: {
    title: 'Produção (R$)',
    slug: 'producao',
    last_updated: String(new Date()),
    subtitles: [
      {
        title: 'Produção em R$',
        color: 'primary.500'
      }
    ],
    type: 'currency'
  },
  spread: {
    title: '% de Spread',
    slug: 'spread',
    last_updated: String(new Date()),
    subtitles: [
      {
        title: 'Spread Bruto',
        color: 'primary.500'
      },
      {
        title: 'Spread Líquido',
        color: 'primary.300'
      }
    ],
    type: 'percentage'
  },
  potential: {
    title: 'Potencial (R$)',
    slug: 'potencial',
    last_updated: String(new Date()),
    subtitles: [
      {
        title: 'Potencial em R$',
        color: 'primary.500'
      }
    ],
    type: 'currency'
  },
  mktShare: {
    title: 'Market Share %',
    slug: 'market_share',
    last_updated: String(new Date()),
    subtitles: [
      {
        title: 'Market Share %',
        color: 'primary.500'
      }
    ],
    type: 'percentage'
  },
  mktVisualization: {
    title: 'Visualização de mercado %',
    slug: 'visao_de_mercado',
    last_updated: String(new Date()),
    subtitles: [
      {
        title: 'Visualização de mercado %',
        color: 'primary.500'
      }
    ],
    type: 'percentage'
  },
  creditLifeInsurance: {
    title: 'Seguro Prestamista',
    slug: 'seguro_prestamista',
    last_updated: String(new Date()),
    subtitles: [
      {
        title: '% IP Seguro Prestramista (QTD)',
        color: 'primary.500'
      },
      {
        title: '% IP Seguro Prestramista (Volume)',
        color: 'primary.300'
      }
    ],
    type: 'percentage'
  },
  santanderAutoInsurance: {
    title: 'Seguro Santander Auto',
    slug: 'seguro_santander_auto',
    last_updated: String(new Date()),
    subtitles: [
      {
        title: '% IP Seguro Auto (QTD)',
        color: 'primary.500'
      }
    ],
    type: 'currency'
  },
  typesSantanderAuto: {
    title: 'Santander Auto Tipos',
    slug: 'santander_auto_tipos',
    last_updated: String(new Date()),
    subtitles: [
      {
        title: 'Seguro Completo',
        color: 'primary.800'
      },
      {
        title: 'Seguro Incêndio Roubo e Furto',
        color: 'primary.500'
      },
      {
        title: 'Seguros Terceiros',
        color: 'gray.200'
      },
      {
        title: 'Seguros Avulsa',
        color: 'primary.300'
      }
    ],
    type: 'qtd'
  },
  accountAmount: {
    title: 'Quantidade de Contas',
    slug: 'qtd_de_contas',
    last_updated: String(new Date()),
    subtitles: [
      {
        title: 'Contas Abertas',
        color: 'primary.500'
      }
    ],
    type: 'qtd'
  },
  webmotors: {
    title: 'Webmotors',
    slug: 'webmotors',
    last_updated: String(new Date()),
    subtitles: [
      {
        title: 'Faturamento Webmotors (R$)',
        color: 'primary.500'
      }
    ],
    type: 'currency'
  },
  fpd10: {
    title: 'FPD10',
    slug: 'fpd10',
    last_updated: String(new Date()),
    subtitles: [
      {
        title: 'Contratos FPD10 (%)',
        color: 'primary.500'
      }
    ],
    type: 'percentage'
  },
  over30m3: {
    title: 'Over30 M3',
    slug: 'over30_m3',
    last_updated: String(new Date()),
    subtitles: [
      {
        title: 'Over30 M3 (%)',
        color: 'primary.300'
      }
    ],
    type: 'percentage'
  }
}

export const getDescriptionContract = (type: PANELS_TYPES_ENUM, monthYear: string) => {
  switch (type) {
    case PANELS_TYPES_ENUM.PRODUCTION:
      return `Produção ${monthYear} (R$)`

    case PANELS_TYPES_ENUM.MARKETING_SHARE:
      return 'Produção (R$)'

    case PANELS_TYPES_ENUM.CREDIT_LIFE_INSURANCE:
      return '% IP Seguro Prestramista (Volume)'

    case PANELS_TYPES_ENUM.OVER30_M3:
      return `Over 30 M3 ${monthYear} (%)`

    case PANELS_TYPES_ENUM.FPD10:
      return `Contratos FPD10 ${monthYear} (%)`

    case PANELS_TYPES_ENUM.SANTANDER_AUTO_INSURANCE:
      return '% IP Seguro Auto (QTD)'
  }
}
